import { useTranslation } from 'react-i18next'
import PageModal from '../common/PageModal'
import SimpleButton from '../common/SimpleButton'
import { branchesWritePermission } from '../../utils/permissionValidation'
import countries from '../../utils/countries.json'
import './companies-management-modal.scss'

const ViewBranch = (props) => {
  const { t } = useTranslation()
  const { selectedBranch, handleEditBranch, closeModal } = props

  const branchFooterContent = () => {
    return (
      <>
        <SimpleButton className="cancel-button" onClick={closeModal}>
          {t('close')}
        </SimpleButton>
        <SimpleButton className="action-button" onClick={handleEditBranch} requiredPermission={branchesWritePermission}>
          {t('edit')}
        </SimpleButton>
      </>
    )
  }

  return (
    <>
      <PageModal toggle onToggle={closeModal} className="companies-management-modal" title={t('details')} footerContent={branchFooterContent()}>
        <div className="companies-management-modal-content">
          <div className="section-title">{t('general_information').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('users-management.company_account_type')}</p>
              <div className="value">{selectedBranch.account}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('organization_context.corporate_branch')}</p>
              <div className="value">{selectedBranch.company?.isCorporation ? t('yes') : t('no')}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('organization')}</p>
              <div className="value">{selectedBranch.company?.name}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('branch')}</p>
              <div className="value">{selectedBranch.branchName}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('organization_context.branch_admin')}</p>
              <div className="value">{selectedBranch.email}</div>
            </div>
          </div>
          <div className="separator" />
          <div className="section-title">{t('location').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('phone')}</p>
              <div className="value">{selectedBranch.telephone}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('region')}</p>
              <div className="value">{selectedBranch.region}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('country')}</p>
              <div className="value">{countries.find((c) => c.code === selectedBranch.country)?.name}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('address')}</p>
              <div className="value">{selectedBranch.officeAddressOne}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('city')}</p>
              <div className="value">{selectedBranch.city}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('state_province')}</p>
              <div className="value">{selectedBranch.stateProvinceRegion}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('zip_postal_code')}</p>
              <div className="value">{selectedBranch.zipPostalCode}</div>
            </div>
          </div>
          <div className="separator" />
          <div className="section-title">{t('fleet').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('nav.members')}</p>
              <div className="value">{selectedBranch.members}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('devices')}</p>
              <div className="value">{selectedBranch.totalDevices}</div>
            </div>
          </div>
        </div>
      </PageModal>
    </>
  )
}

export default ViewBranch
